/** Desk landline — no WhatsApp shortcut next to this number in the UI */
export const PHONE_DESK_DIGITS = "40343101131";

export function digitsOnly(s) {
  return String(s || "").replace(/\D/g, "");
}
